import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import 'leaflet/dist/leaflet.css';
import './Maps.css';

import {BrowserView, MobileView} from 'react-device-detect';
import MapsBrowser from './MapsBrowser';
import MapsMobile from './MapsMobile';

import useHook from './maps.hooks';
import localforage from 'localforage';

const useStyles = makeStyles((theme) => ({
  body: {},
}));

const Maps = (props) => {
  const classes = useStyles();
  const [
    {mapRef, baseLayerChange, zoomEnd, dragEnd},
    {kelurahanRefGeoJson, getKelurahan, zoomKelurahan},
    {blokRefGeoJson, getBlok, zoomBlok},
    {persilRefGeoJson, getPersil, zoomPersil},
    {zntRefGeoJson, getZnt},
    {markerPbbRefGeoJson, getMarkerPbb},
    {markerBphtbRefGeoJson, getMarkerBphtb},
    {markerHotelRefGeoJson, getMarkerHotel},
    {markerRestoranRefGeoJson, getMarkerRestoran},
    {markerHiburanRefGeoJson, getMarkerHiburan},
    {markerReklameRefGeoJson, getMarkerReklame},
    {markerPpjRefGeoJson, getMarkerPpj},
    {markerParkirRefGeoJson, getMarkerParkir},
    {markerPatRefGeoJson, getMarkerPat},
    {markerWaletRefGeoJson, getMarkerWalet},
    {markerMblbRefGeoJson, getMarkerMblb},
    {markerPendataanRefGeoJson, getMarkerPendataan},
    {
      inputNop,
      setInputNop,
      inputKelurahan,
      setInputKelurahan,
      facebookProgress,
      clearIcon,
      handleKeyPress,
      handleKeyPressKelurahan,
      onClear,
      onSearchNop,
      onSearchKelurahan,
    },
    {checked, handleDetails},
    {monografiKelurahan, setMonografiKelurahan, handleMonografiKelurahan},
    {detailMonografiKelurahan, setDetailMonografiKelurahan},
    {chartMonografiKelurahan, setChartMonografiKelurahan},
    {
      searchNop,
      searchKelurahan,
      searchSppt,
      piutangLoading,
      tahunSPPT,
      handleTahunSPPT,
      itemTahunSPPT,
      detailNop,
      detailKelurahan,
      detailSppt,
      images,
      streetView,
    },
  ] = useHook();

  // const history = useHistory();
  // useEffect(() => {
  //   localforage.getItem('token').then((response) => {
  //     if (!response) {
  //       history.push('/login');
  //     }
  //   });
  // }, [history]);

  return (
    <div className={classes.body} id="printMap">
      {/*Browser View*/}
      <BrowserView>
        <MapsBrowser
          mapRef={mapRef}
          baseLayerChange={baseLayerChange}
          zoomEnd={zoomEnd}
          dragEnd={dragEnd}
          kelurahanRefGeoJson={kelurahanRefGeoJson}
          getKelurahan={getKelurahan}
          blokRefGeoJson={blokRefGeoJson}
          getBlok={getBlok}
          persilRefGeoJson={persilRefGeoJson}
          getPersil={getPersil}
          zntRefGeoJson={zntRefGeoJson}
          getZnt={getZnt}
          markerPbbRefGeoJson={markerPbbRefGeoJson}
          getMarkerPbb={getMarkerPbb}
          markerBphtbRefGeoJson={markerBphtbRefGeoJson}
          getMarkerBphtb={getMarkerBphtb}
          markerHotelRefGeoJson={markerHotelRefGeoJson}
          getMarkerHotel={getMarkerHotel}
          markerRestoranRefGeoJson={markerRestoranRefGeoJson}
          getMarkerRestoran={getMarkerRestoran}
          markerHiburanRefGeoJson={markerHiburanRefGeoJson}
          getMarkerHiburan={getMarkerHiburan}
          markerReklameRefGeoJson={markerReklameRefGeoJson}
          getMarkerReklame={getMarkerReklame}
          markerPpjRefGeoJson={markerPpjRefGeoJson}
          getMarkerPpj={getMarkerPpj}
          markerParkirRefGeoJson={markerParkirRefGeoJson}
          getMarkerParkir={getMarkerParkir}
          markerPatRefGeoJson={markerPatRefGeoJson}
          getMarkerPat={getMarkerPat}
          markerWaletRefGeoJson={markerWaletRefGeoJson}
          getMarkerWalet={getMarkerWalet}
          markerMblbRefGeoJson={markerMblbRefGeoJson}
          getMarkerMblb={getMarkerMblb}
          markerPendataanRefGeoJson={markerPendataanRefGeoJson}
          getMarkerPendataan={getMarkerPendataan}
          inputNop={inputNop}
          setInputNop={setInputNop}
          inputKelurahan={inputKelurahan}
          setInputKelurahan={setInputKelurahan}
          facebookProgress={facebookProgress}
          clearIcon={clearIcon}
          handleKeyPress={handleKeyPress}
          handleKeyPressKelurahan={handleKeyPressKelurahan}
          onClear={onClear}
          onSearchNop={onSearchNop}
          onSearchKelurahan={onSearchKelurahan}
          checked={checked}
          handleDetails={handleDetails}
          monografiKelurahan={monografiKelurahan}
          setMonografiKelurahan={setMonografiKelurahan}
          handleMonografiKelurahan={handleMonografiKelurahan}
          detailMonografiKelurahan={detailMonografiKelurahan}
          setDetailMonografiKelurahan={setDetailMonografiKelurahan}
          chartMonografiKelurahan={chartMonografiKelurahan}
          setChartMonografiKelurahan={setChartMonografiKelurahan}
          searchNop={searchNop}
          searchKelurahan={searchKelurahan}
          searchSppt={searchSppt}
          piutangLoading={piutangLoading}
          tahunSPPT={tahunSPPT}
          handleTahunSPPT={handleTahunSPPT}
          itemTahunSPPT={itemTahunSPPT}
          detailNop={detailNop}
          detailKelurahan={detailKelurahan}
          detailSppt={detailSppt}
          images={images}
          streetView={streetView}
        />
      </BrowserView>

      {/*Mobile View*/}
      <MobileView>
        <MapsMobile
          mapRef={mapRef}
          baseLayerChange={baseLayerChange}
          zoomEnd={zoomEnd}
          dragEnd={dragEnd}
          kelurahanRefGeoJson={kelurahanRefGeoJson}
          getKelurahan={getKelurahan}
          blokRefGeoJson={blokRefGeoJson}
          getBlok={getBlok}
          persilRefGeoJson={persilRefGeoJson}
          getPersil={getPersil}
          zntRefGeoJson={zntRefGeoJson}
          getZnt={getZnt}
          markerPbbRefGeoJson={markerPbbRefGeoJson}
          getMarkerPbb={getMarkerPbb}
          markerBphtbRefGeoJson={markerBphtbRefGeoJson}
          getMarkerBphtb={getMarkerBphtb}
          markerHotelRefGeoJson={markerHotelRefGeoJson}
          getMarkerHotel={getMarkerHotel}
          markerRestoranRefGeoJson={markerRestoranRefGeoJson}
          getMarkerRestoran={getMarkerRestoran}
          markerHiburanRefGeoJson={markerHiburanRefGeoJson}
          getMarkerHiburan={getMarkerHiburan}
          markerReklameRefGeoJson={markerReklameRefGeoJson}
          getMarkerReklame={getMarkerReklame}
          markerPpjRefGeoJson={markerPpjRefGeoJson}
          getMarkerPpj={getMarkerPpj}
          markerParkirRefGeoJson={markerParkirRefGeoJson}
          getMarkerParkir={getMarkerParkir}
          markerPatRefGeoJson={markerPatRefGeoJson}
          getMarkerPat={getMarkerPat}
          markerWaletRefGeoJson={markerWaletRefGeoJson}
          getMarkerWalet={getMarkerWalet}
          markerMblbRefGeoJson={markerMblbRefGeoJson}
          getMarkerMblb={getMarkerMblb}
          markerPendataanRefGeoJson={markerPendataanRefGeoJson}
          getMarkerPendataan={getMarkerPendataan}
          inputNop={inputNop}
          setInputNop={setInputNop}
          inputKelurahan={inputKelurahan}
          setInputKelurahan={setInputKelurahan}
          facebookProgress={facebookProgress}
          clearIcon={clearIcon}
          handleKeyPress={handleKeyPress}
          handleKeyPressKelurahan={handleKeyPressKelurahan}
          onClear={onClear}
          onSearchNop={onSearchNop}
          onSearchKelurahan={onSearchKelurahan}
          checked={checked}
          handleDetails={handleDetails}
          monografiKelurahan={monografiKelurahan}
          setMonografiKelurahan={setMonografiKelurahan}
          handleMonografiKelurahan={handleMonografiKelurahan}
          detailMonografiKelurahan={detailMonografiKelurahan}
          setDetailMonografiKelurahan={setDetailMonografiKelurahan}
          chartMonografiKelurahan={chartMonografiKelurahan}
          setChartMonografiKelurahan={setChartMonografiKelurahan}
          searchNop={searchNop}
          searchKelurahan={searchKelurahan}
          searchSppt={searchSppt}
          piutangLoading={piutangLoading}
          tahunSPPT={tahunSPPT}
          handleTahunSPPT={handleTahunSPPT}
          itemTahunSPPT={itemTahunSPPT}
          detailNop={detailNop}
          detailKelurahan={detailKelurahan}
          detailSppt={detailSppt}
          images={images}
          streetView={streetView}
        />
      </MobileView>
    </div>
  );
};

export default Maps;
